import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { Form, Button } from "react-bootstrap";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";

const CreateBanner = () => {
  const navigate = useNavigate();
  const [collegeData, setCollegeData] = useState<any[]>([]);

  const [formData, setFormData] = useState<any>({
    headerImage: null,
    collegeId: "",
    collegeName: "",
  });

  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    getColleges();
  }, []);

  const getColleges = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
      type: "registerNow",
    };

    AdminService.allCollege(data).then((res: any) => {
      if (res.status === "Success") {
        setCollegeData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleInput = (e: any) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
      setFormData((prev: any) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev: any) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCollegeChange = (e: any) => {
    const selectedCollege = collegeData.find(
      (item: any) => item._id === e.target.value
    );

    setFormData((prev: any) => ({
      ...prev,
      collegeId: selectedCollege?._id || "",
      collegeName: selectedCollege?.collegeName || "",
    }));

    setErrors((prev: any) => ({
      ...prev,
      collegeName: "",
    }));
  };

  const validate = () => {
    const newErrors: any = {};

    if (!formData.collegeId) {
      newErrors.collegeName = "College Name is required";
    }

    if (!formData.headerImage) {
      newErrors.headerImage = "Header Image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegister = (e: any) => {
    e.preventDefault();

    const loginData: any = sessionStorage.getItem("loginData");
    const data = JSON.parse(loginData);

    if (validate()) {
      const formDataToSubmit = new FormData();

      formDataToSubmit.append("headerImage", formData.headerImage);
      formDataToSubmit.append("collegeId", formData.collegeId);
      formDataToSubmit.append("collegeName", formData.collegeName);
      formDataToSubmit.append("userName", data.email);

      AdminService.createHeaderData(formDataToSubmit).then((res: any) => {
        if (res.status === "Fail") {
          toast.error(res.error);
        } else {
          toast.success(res.message);
          navigate("/exam/bannerList");
        }
      });
    }
  };

  const handleCancel = () => {
    navigate("/exam/bannerList");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>

      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>

        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 style={{ textAlign: "left" }}>
            <b>Add New Header Image</b>
          </h4>

          <Form>
            <div className="row">
              <div className="col-md-12">
                <Form.Group controlId="headerImage" className="mt-3">
                  <Form.Label>Header Image *</Form.Label>
                  <Form.Control
                    type="file"
                    name="headerImage"
                    onChange={handleInput}
                    className={errors.headerImage ? "is-invalid" : ""}
                  />

                  {errors.headerImage && (
                    <div className="invalid-feedback">
                      {errors.headerImage}
                    </div>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group controlId="collegeName" className="mt-3">
                  <Form.Label>College Name *</Form.Label>

                  <Form.Select
                    value={formData.collegeId}
                    onChange={handleCollegeChange}
                    className={errors.collegeName ? "is-invalid" : ""}
                  >
                    <option value="">Select College</option>

                    {collegeData?.map((item: any) => (
                      <option key={item._id} value={item._id}>
                        {item.collegeName}
                      </option>
                    ))}
                  </Form.Select>

                  {errors.collegeName && (
                    <div className="invalid-feedback">
                      {errors.collegeName}
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="mt-3">
              <Button
                variant="primary"
                type="submit"
                className="me-2"
                onClick={handleRegister}
              >
                Create
              </Button>

              <Button
                variant="secondary"
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CreateBanner;